import FilterControls from './FilterControls.component';

export default FilterControls;
